import {useApi} from "~/composables/api/utils/useApi"

export const usePaymentMethodApi = () => ({
  async getList() {
    const url = `payment-methods`
    const api = useApi()

    try {
      return api.makeRequest(url, 'get')
    } catch (err) {
      throw err
    }
  }
})
